import React, { useState } from "react";
import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../Assets/logo.png";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;

    setSuccess(true);
    setEmail("");

    setTimeout(() => setSuccess(false), 3000);
  };

  return (
    <footer className="bg-white text-gray-800 pt-20 pb-10 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6">

        {/* TOP CTA */}
        <div className="mb-16 text-center">
          <h3 className="text-3xl font-semibold mb-3">
            Grow Your Business with <span className="text-purple-600">Poeage</span> 🚀
          </h3>

          <p className="text-gray-500 mb-6">
            Get insights and strategies to scale your digital growth.
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row justify-center gap-3"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="px-5 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-purple-500 w-full sm:w-[320px]"
            />

            <button className="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition">
              Subscribe
            </button>
          </form>

          {success && (
            <p className="text-green-500 mt-3 text-sm">
              ✅ Successfully subscribed!
            </p>
          )}
        </div>

        {/* MAIN GRID */}
        <div className="grid md:grid-cols-4 gap-10 mb-12">

          {/* BRAND */}
          <div>
            <img src={logo} alt="Poeage Logo" className="h-10 mb-4" />
            <p className="text-sm text-gray-500 leading-relaxed">
              Poeage Digital Marketing helps businesses grow with data-driven
              strategies and scalable systems.
            </p>
          </div>

          {/* COMPANY */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Company</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/about" className="hover:text-purple-600">About Us</Link></li>
              <li><Link to="/career" className="hover:text-purple-600">Careers</Link></li>
              <li><Link to="/services" className="hover:text-purple-600">Services</Link></li>
              <li><Link to="/pricing" className="hover:text-purple-600">Pricing</Link></li>
            </ul>
          </div>

          {/* SERVICES (FULL) */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Services</h4>
            <ul className="space-y-2 text-sm text-gray-500">

              <li><Link to="/services" className="hover:text-purple-600">SEO Optimization</Link></li>
              <li><Link to="/services" className="hover:text-purple-600">Performance Marketing</Link></li>
              <li><Link to="/services" className="hover:text-purple-600">Social Media Marketing</Link></li>
              <li><Link to="/services" className="hover:text-purple-600">Website Development</Link></li>
              <li><Link to="/services" className="hover:text-purple-600">Brand Strategy</Link></li>
              <li><Link to="/services" className="hover:text-purple-600">CRM Setup</Link></li>

            </ul>
          </div>

          {/* SOCIAL */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Connect</h4>

            <div className="flex gap-3">
              {[Facebook, Instagram, Twitter, Linkedin].map((Icon, i) => (
                <div
                  key={i}
                  className="p-2 border border-gray-300 rounded-lg hover:bg-purple-600 hover:text-white transition cursor-pointer"
                >
                  <Icon size={18} />
                </div>
              ))}
            </div>

            {/* CONTACT INFO */}
            <div className="mt-6 text-sm text-gray-500">
              <p>Email: info@poeage.com</p>
              <p>Phone: +91 73580 35616</p>
            </div>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>© {new Date().getFullYear()} Poeage Digital Marketing</p>

          <div className="flex gap-6 mt-4 md:mt-0">
            <span className="hover:text-purple-600 cursor-pointer">Privacy</span>
            <span className="hover:text-purple-600 cursor-pointer">Terms</span>
            <span className="hover:text-purple-600 cursor-pointer">Security</span>
          </div>
        </div>

      </div>
    </footer>
  );
}